import React from 'react';
import './Header.css';

const Header = () => {
    return (
      <div className= "header-bienvenida">
        <div className= "contenedor-texto">
          <div className= "titulo-inicio">
            <p className= "h2-titulo">
              Bienvenido a Servicios Escolares
            </p>
          </div>
          <div className= "subtitulo-inicio">
            <p>
              American English Academy
            </p>
          </div>
        </div>
      </div>
    );
  };
  
export default Header;